<template>
    <div>
        <b-container>
            <div>
                <b-row class="mt-5 px-5">
                    <b-col lg="5">
                        <p class="gotham-bold h6">
                            VIEW THE NEXT PROJECT
                        </p>
                        <nuxt-link :to="nextProject.link" class="text-black h3">{{nextProject.name}}</nuxt-link>
                    </b-col>
                    <b-col lg="7">
                        <div class="d-flex align-items-end h-100">
                            <nuxt-link :to="nextProject.link" 
                            class="">
                                <img src="/img/ga-next-project-arrow.png" alt="Arrow" class="w-100 d-block">
                            </nuxt-link>
                        </div>
                    </b-col>
                </b-row>
            </div>
        </b-container>
    </div>
</template>

<script>
export default {
    props: ['nextProject']
}
</script>